import React from 'react';
import RootCloseWrapper from 'react-overlays/lib/RootCloseWrapper';
import { Dropdown } from 'react-bootstrap';
import { createChainedFunction } from 'react-bootstrap/lib/utils';

class CustomMenu extends Dropdown.Menu {
  constructor(props, context) {
    super(props, context);
    this.state = {
      keyword: ''
    };
  }

  handleChange = (e) =>  {
    this.setState({ keyword: e.target.value });
  }

  handleRootClose = event => {
    this.props.onClose(event, { source: 'rootClose' });
  }
  
  handleSelect = () => {
    this.setState({ keyword: '' })
  }

  render() {
    const { children, open, rootCloseEvent, onSelect, id } = this.props;
    const { keyword } = this.state;
    const childrenArray = React.Children.toArray(children);
    return <RootCloseWrapper
      disabled={!open}
      onRootClose={this.handleRootClose}
      event={rootCloseEvent}
    >
      <div id={id} className="super-colors dropdown-menu" style={{ padding: '' }}>
        {childrenArray.length > 0 && <input
          className="rw-input"
          style={{width: '100%'}}
          type="text"
          placeholder="Type to filter..."
          onChange={this.handleChange}
          value={keyword}
        />}
        {childrenArray.filter(
          child => !keyword.trim() || child.props.children.toLowerCase().includes(keyword.toLowerCase()) !== false
        ).map(child => React.cloneElement(child, {
          onKeyDown: createChainedFunction(
            child.props.onKeyDown, this.handleKeyDown,
          ),
          onSelect: createChainedFunction(
            child.props.onSelect, onSelect, this.handleSelect
          ),
        }))}
      </div>
    </RootCloseWrapper>
  }
}

export default {
  Menu: CustomMenu
}


// WEBPACK FOOTER //
// ./master/jsx/components/Common/customDropdown.jsx